import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Globals from '../../../core/globals';
import { OfflineCache } from '../../services/OfflineCache';

function CampaignOverviewAndroid() {
    const [campaigns, setCampaigns] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchCampaigns = async () => {
            try {
                const token = localStorage.getItem('authToken');
                const response = await axios.get(`${Globals.backendUri}/campaigns/all`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                const list = (response.data || []);
                setCampaigns(list);
                OfflineCache.saveCampaigns(list);
            } catch (e) {
                const cached = OfflineCache.getCampaigns();
                if (cached.length) setCampaigns(cached);
            } finally {
                setLoading(false);
            }
        };
        fetchCampaigns();
    }, []);

    const openCampaign = (id) => {
        window.location.hash = `#/campaigns/${id}`;
    };

    const now = new Date();
    const upcomingCampaigns = campaigns.filter(c => new Date(c.releaseDate) >= now).sort((a, b) => new Date(a.releaseDate) - new Date(b.releaseDate));
    const pastCampaigns = campaigns.filter(c => new Date(c.releaseDate) < now).sort((a, b) => new Date(b.releaseDate) - new Date(a.releaseDate));

    return (
        <div className="px-4 py-4">
            <div className="flex items-center justify-between mb-3">
                <h1 className="text-2xl font-bold">Campaigns</h1>
                <button className="bg-blue-600 text-white rounded-md px-4 py-3 text-base" onClick={() => window.location.hash = '#/campaigns/create'}>Create</button>
            </div>
            {loading ? (
                <div className="text-center py-8">Loading...</div>
            ) : (
                <div>
                    {/* Upcoming Campaigns */}
                    {upcomingCampaigns.length > 0 && (
                        <div className="mb-6">
                            <h2 className="text-xl font-semibold mb-3 text-green-700">🎵 Upcoming Campaigns</h2>
                            <div className="rounded-md border divide-y">
                                {upcomingCampaigns.map(c => (
                                    <button key={c.id} className="w-full text-left px-4 py-3 active:bg-gray-50 flex items-center" onClick={() => openCampaign(c.id)}>
                                        {c.artworkUrl ? (
                                            <img src={c.artworkUrl} alt={c.name} className="w-16 h-16 object-cover rounded mr-3" />
                                        ) : (
                                            <div className="w-16 h-16 bg-gray-200 rounded mr-3 flex items-center justify-center text-xs text-gray-500">No Image</div>
                                        )}
                                        <div className="flex-1">
                                            <p className="font-semibold">{c.name}</p>
                                            <p className="text-sm text-gray-600">{c.artistName}</p>
                                            <p className="text-sm text-gray-500">{new Date(c.releaseDate).toLocaleDateString('de-DE')}</p>
                                        </div>
                                    </button>
                                ))}
                            </div>
                        </div>
                    )}

                    {/* Past Campaigns */}
                    {pastCampaigns.length > 0 && (
                        <div>
                            <h2 className="text-xl font-semibold mb-3 text-gray-600">📀 Released Campaigns</h2>
                            <div className="rounded-md border divide-y">
                                {pastCampaigns.map(c => (
                                    <button key={c.id} className="w-full text-left px-4 py-3 active:bg-gray-50 flex items-center" onClick={() => openCampaign(c.id)}>
                                        {c.artworkUrl ? (
                                            <img src={c.artworkUrl} alt={c.name} className="w-16 h-16 object-cover rounded mr-3" />
                                        ) : (
                                            <div className="w-16 h-16 bg-gray-200 rounded mr-3 flex items-center justify-center text-xs text-gray-500">No Image</div>
                                        )}
                                        <div className="flex-1">
                                            <p className="font-semibold">{c.name}</p>
                                            <p className="text-sm text-gray-600">{c.artistName}</p>
                                            <p className="text-sm text-gray-500">{new Date(c.releaseDate).toLocaleDateString('de-DE')}</p>
                                        </div>
                                    </button>
                                ))}
                            </div>
                        </div>
                    )}

                    {/* No Campaigns */}
                    {upcomingCampaigns.length === 0 && pastCampaigns.length === 0 && (
                        <div className="text-center py-8 text-gray-500">
                            <p>No campaigns found</p>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}

export default CampaignOverviewAndroid;


